module.exports = __webpack_public_path__ + "img/status-change.d4d6ec3f.png";